(() => {
  const config = JSON.parse(document.querySelector('[data-welcome-config]')?.textContent || '{}');
  // Offre de bienvenue −10 % arrêtée le 23/10/2026 : aucune remise n'est plus calculée.
  const firstOrder = false;
  try { sessionStorage.removeItem('anya_first_order'); } catch (e) {}
  const calculate = (amount) => {
    const cents = Math.max(0, Math.round(Number(amount) * 100));
    const discount = firstOrder ? Math.round(cents / 1000) : 0;
    return { discount, net: (cents - discount * 100) / 100 };
  };
  const sync = () => {
    document.querySelectorAll('[data-welcome-first]').forEach(input => {
      input.checked = firstOrder;
      input.disabled = Boolean(config.known_customer);
    });
  };
  window.AnyaWelcome = {
    calculate,
    lines(amount, currency) {
      const result = calculate(amount);
      return result.discount > 0 ? [
        config.discount_label + ' : − ' + result.discount.toLocaleString('fr-FR') + ' ' + currency,
        config.confirmation
      ] : [];
    },
    totalLabel: config.total_label
  };
  sync();
})();
